import CollectOutlineIcon from '@/assets/collect-outline.svg?react'
import DeleteOutlineIcon from '@/assets/delete-outline.svg?react'
import LinkIcon from '@/assets/link.svg?react'
import { IconPhoto } from '@tabler/icons-react'
import RepostIcon from '@/assets/repost.svg?react'
import StickStickIcon from '@/assets/stick-stick.svg?react'
import StickUnstickIcon from '@/assets/stick-unstick.svg?react'
import UncollectOutlineIcon from '@/assets/uncollect-outline.svg?react'
import JikeYellowLogoIcon from '@/components/Icons/JikeYellowLogoIcon'
import type { MenuItemData } from '../DropdownMenu/types'
import styles from './config.module.css'

export enum ActionMenu {
	COPY_LINK = 'COPY_LINK',
	COPY_SHARE_IMAGE = 'COPY_SHARE_IMAGE',
	PIN = 'PIN',
	UNPIN = 'UNPIN',
	COLLECT = 'COLLECT',
	UNCOLLECT = 'UNCOLLECT',
	TO_SELF_ONLY = 'TO_SELF_ONLY',
	TO_PUBLIC = 'TO_PUBLIC',
	EDIT_POST = 'EDIT_POST',
	DELETE = 'DELETE',
	REPOST = 'REPOST',
}

export const ACTION_MENU_LOCALE: Record<ActionMenu, MenuItemData> = {
	[ActionMenu.COPY_SHARE_IMAGE]: {
		icon: <IconPhoto />,
		title: '复制分享图',
		id: ActionMenu.COPY_SHARE_IMAGE,
	},
	[ActionMenu.REPOST]: {
		icon: <RepostIcon />,
		title: '转发动态',
		id: ActionMenu.REPOST,
	},
	[ActionMenu.COPY_LINK]: {
		icon: <LinkIcon />,
		title: '复制链接',
		id: ActionMenu.COPY_LINK,
	},
	[ActionMenu.PIN]: {
		icon: <StickStickIcon />,
		title: '置顶',
		id: ActionMenu.PIN,
	},
	[ActionMenu.UNPIN]: {
		icon: <StickUnstickIcon />,
		title: '取消置顶',
		id: ActionMenu.UNPIN,
	},
	[ActionMenu.COLLECT]: {
		icon: <CollectOutlineIcon />,
		title: '收藏',
		id: ActionMenu.COLLECT,
	},
	[ActionMenu.UNCOLLECT]: {
		icon: <UncollectOutlineIcon />,
		title: '取消收藏',
		id: ActionMenu.UNCOLLECT,
	},
	[ActionMenu.TO_SELF_ONLY]: {
		icon: <JikeYellowLogoIcon />,
		title: '转为仅自己可见',
		id: ActionMenu.TO_SELF_ONLY,
	},
	[ActionMenu.TO_PUBLIC]: {
		icon: <JikeYellowLogoIcon />,
		title: '转为公开',
		id: ActionMenu.TO_PUBLIC,
	},
	[ActionMenu.EDIT_POST]: {
		icon: <JikeYellowLogoIcon />,
		title: '编辑动态',
		id: ActionMenu.EDIT_POST,
	},
	[ActionMenu.DELETE]: {
		icon: <DeleteOutlineIcon />,
		title: '删除',
		id: ActionMenu.DELETE,
		props: {
			className: styles.deleteMenuItem,
		},
	},
}
